import { render } from "./pay-success.vue?vue&type=template&id=42cb2df4&scoped=true&ts=true"
import script from "./pay-success.vue?vue&type=script&lang=ts"
export * from "./pay-success.vue?vue&type=script&lang=ts"

import "./pay-success.vue?vue&type=style&index=0&id=42cb2df4&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cb2df4"]])

export default __exports__